import React from "react";

// Material-UI
import { Container, makeStyles, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Card from "@material-ui/core/Card";
// Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import Footer from "../components/Footer";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  section: {
    margin: theme.spacing(2, 0),
  },
  paper: {
    padding: theme.spacing(3)
  },
  link: {
    textDecoration: "none",
    color: "white",
  },
  title: {
    marginBottom: theme.spacing(3)
  }
}));

const InformasiKelulusan = ({ classes }) => {
  return (
    <section id="informasi-kelulusan">
      <Container>
        <Card className={classes.section} elevation={3}>
          <Alert variant="filled" severity="error">
            <AlertTitle>{"Mohon maaf, anda dinyatakan TIDAK LULUS"}</AlertTitle>
            <Typography variant="body2">
              {"Berdasarkan hasil dari Nilai Akhir anda yang dibawah dari Standar Nilai Kelulusan (KKM), maka panitia menyatakan anda belum dapat bergabung kedalam KSR PMI Unit UNJ. Tetap Semangat dan Jangan Menyerah!"}
            </Typography>
          </Alert>
        </Card>
      </Container>
    </section>
  );
};


const UserStatusKelulusanTidakLulus = () => {
  const classes = useStyles();

  return (
    <section id="status-kelulusan" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Status Kelulusan" />
          <InformasiKelulusan classes={classes} />
      </Container>
      <Footer />
    </section>
  );
};

export default UserStatusKelulusanTidakLulus;
